import SuperRepository from '../superRepository'

export default new (class ClicksRepository extends SuperRepository {
  baseUri() {
    return 'click'
  }
  exportClicksReportToken = (data, params) => this.reportHttpClient().postQuery('export/click/token', data, params)
})()
